import { useEffect } from 'react';
import { useLocale } from '../context/LocaleContext';
import { LANGUAGES } from '../i18n/translations';

// Injects hreflang alternate tags + updates <html lang> for SEO
const SeoLangTags = () => {
  const { language } = useLocale();

  useEffect(() => {
    // Set html lang
    try {
      document.documentElement.lang = language;
    } catch (err) {
      console.error('[SEO] failed to set html lang:', err);
    }

    // Remove any previous alt tags we injected
    document.querySelectorAll('link[data-feron-hreflang]').forEach((l) => l.remove());

    const baseUrl = window.location.origin + window.location.pathname;
    LANGUAGES.forEach((l) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = l.code;
      link.href = `${baseUrl}?lang=${l.code}`;
      link.setAttribute('data-feron-hreflang', '1');
      document.head.appendChild(link);
    });
    // x-default
    const def = document.createElement('link');
    def.rel = 'alternate';
    def.hreflang = 'x-default';
    def.href = baseUrl;
    def.setAttribute('data-feron-hreflang', '1');
    document.head.appendChild(def);
  }, [language]);

  return null;
};

export default SeoLangTags;
